const desktopQuery = window.matchMedia('(min-width: 1401px)');
const mobileQuery = window.matchMedia('(max-width: 1400px)');
const roots = document.querySelectorAll('.wp-block-acf-mega-menu');

if (roots.length) {
  const closeMenus = (root) => {
    root.querySelectorAll('.nav-item.open').forEach((item) => {
      item.classList.remove('open');
      item.querySelector(':scope > button')?.setAttribute('aria-expanded', 'false');
    });
  };

  const openItem = (root, item) => {
    closeMenus(root);
    item.classList.add('open');
    item.querySelector(':scope > button')?.setAttribute('aria-expanded', 'true');
  };

  const setDrawerOpen = (root, open) => {
    const drawer = root.querySelector('.nav-drawer');
    const toggle = root.querySelector('.mega-menu-toggle');
    if (!drawer) {
      return;
    }

    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    toggle?.classList.toggle('is-active', open);
    toggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('new-top-nav-drawer-open', open);

    if (open) {
      window.scrollTo(0, 0);
    }
  };

  roots.forEach((root) => {
    let closeTimer;
    const toggle = root.querySelector('.mega-menu-toggle');

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => closeMenus(root), 300);
    };

    toggle?.addEventListener('click', () => {
      const drawer = root.querySelector('.nav-drawer');
      setDrawerOpen(root, !drawer?.classList.contains('open'));
    });

    root.querySelectorAll('.nav-item').forEach((item) => {
      const button = item.querySelector(':scope > button');
      if (!button) {
        return;
      }

      button.addEventListener('click', (event) => {
        event.stopPropagation();
        if (item.classList.contains('open')) {
          closeMenus(root);
        } else {
          openItem(root, item);
        }
      });

      item.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) {
          return;
        }
        clearTimeout(closeTimer);
        openItem(root, item);
      });

      item.addEventListener('mouseleave', scheduleClose);
    });

    root.querySelector('.nav-menu')?.addEventListener('mouseleave', scheduleClose);

    root.querySelectorAll('.drawer-group > button').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.parentElement;
        const wasOpen = group.classList.contains('open');
        root.querySelectorAll('.drawer-group.open').forEach((openGroup) => {
          openGroup.classList.remove('open');
          openGroup.querySelector(':scope > button')?.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          group.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    const closeDrawer = () => setDrawerOpen(root, false);

    root.querySelector('.drawer-close')?.addEventListener('click', closeDrawer);
    root.querySelector('.drawer-scrim')?.addEventListener('click', closeDrawer);
  });

  document.addEventListener('click', (event) => {
    roots.forEach((root) => {
      if (!root.contains(event.target)) {
        closeMenus(root);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }
    roots.forEach((root) => {
      closeMenus(root);
      setDrawerOpen(root, false);
    });
  });

  const handleViewportChange = () => {
    if (desktopQuery.matches) {
      roots.forEach((root) => setDrawerOpen(root, false));
    }
  };

  desktopQuery.addEventListener('change', handleViewportChange);
  mobileQuery.addEventListener('change', handleViewportChange);
}
